import { useTranslation } from "react-i18next";
import { FormAutocomplete, HelpModal, RowInfo, Switch } from "../../common";

const LimitSelect = (props) => {
  const extendedOptions = [
    {
      id: 150,
      name: '150',
    },
    {
      id: 200,
      name: '200',
    },
    {
      id: 500,
      name: '500',
    },
    {
      id: 1000,
      name: '1000',
    },
  ];

  return (
    <FormAutocomplete
      {...props}
      options={[
        ...Array(100)
          .fill()
          .map((_, i) => {
            return {
              id: i,
              name: String(i),
            };
          }),
        ...extendedOptions,
      ]}
      size="small"
      creatable
    />
  );
};

const InteractionsSection = ({ useQuery }) => {
  const { t } = useTranslation();

  return (
    <>
      <RowInfo
        help={
          <HelpModal title={t(`Interaction Limit`)}>
            <p>
              {t(`If 0, unlimited interactions are allowed. If greater than 0, 
              players will have up to this number of interactions before the NPC ignores them.`)}
            </p>
          </HelpModal>
        }
      >
        <LimitSelect
          label={t("Interaction Limit")}
          name="interactions"
          useQuery={useQuery}
        />
      </RowInfo>
      <RowInfo help={(
        <HelpModal title={t(`Interaction Point Penalty`)}>
            <p>{t(`If set to ON, the system will decrement 1 point for each interaction with the NPC.`)}</p>
        </HelpModal>
      )}>
        <Switch
            label={t('Interaction Point Penalty')}
            name="interactions_decrement_points"
            labels={{ on: "On", off: "Off" }}
            on={true}
            off={false}
            useQuery={useQuery}
          />
      </RowInfo>
    </>
  );
};

export default InteractionsSection;
